import React, {useContext} from 'react';
import { string, node, func, bool } from 'prop-types';
import classNames from 'classnames/bind';

import { StaticTextContext } from 'context/StaticTextContext';

import { withErrorBoundary } from 'containers/ErrorBoundary';

import styles from './AutosaggestPopin.module.scss';
const cx = classNames.bind(styles);

const AutosaggestPopin = ({
  children,
  className,
  toggleTooltip,
  tooltipStatus,
  inputLabel,
}) => {
  const {labels} = useContext(StaticTextContext);
  const hidePopin = (event) => {
    event.preventDefault();
    toggleTooltip(false);
  };

  return (
    <div
      className={cx(
        'popin',
        { 'focused-input-field': tooltipStatus },
        className
      )}
    >
      <button type="button" className={cx('btn-back')} onClick={hidePopin}>
        <span className="btn-text">{'< ' + labels.buttonReturnLabel}</span>
        <span className={cx('label')}>{inputLabel}</span>
      </button>
      <div className={cx('content')}>{children}</div>
    </div>
  );
};

AutosaggestPopin.propTypes = {
  className: string,
  inputLabel: string.isRequired,
  tooltipStatus: bool.isRequired,
  toggleTooltip: func.isRequired,
  children: node.isRequired,
};

AutosaggestPopin.defaultProps = {
  className: null,
};

export default withErrorBoundary(AutosaggestPopin);



// WEBPACK FOOTER //
// ./src/components/AutosaggestPopin/AutosaggestPopin.js